/* eslint-disable react/prop-types */
import React, { useEffect, useState } from "react";
import { Table, Button, Modal, ModalFooter, ModalHeader, ModalBody } from "reactstrap";
import { connect } from "react-redux";
import { injectIntl } from "react-intl";
import { notification, Space } from "antd";
import IntlMessages from "../../../helpers/IntlMessages";

let notifyMessage;

const TemplateMessageTable = ({
  templateMessages,
  dropDownValue,
  toggleEdit,
  setFormTitle,
  setFormLang,
  setFormText,
  deleteTemp,
  setDropDownValue,
  settings
}) => {
  const [openDelete, setOpenDelete] = useState(false);
  const [deleteValue, setDeleteValue] = useState();

  const toggleDelete = () => setOpenDelete(!openDelete);

  useEffect(() => {
    if (settings.locale === "en") {
      notifyMessage = "Template deleted successfull";
    } else {
      notifyMessage = "Şablon başarıyla silindi";
    }
  }, [settings.locale]);

  const openNotificationWithIcon = type => {
    notification[type]({
      message: notifyMessage,
      duration: 1.5,
      style: { marginTop: "100px", zIndex: "9999" }
    });
  };
  return (
    <div>
      <Table className="mt-3" bordered responsive striped style={{ overflow: "hidden" }}>
        <thead>
          <tr>
            <th>
              <IntlMessages id="template.language" />
            </th>
            <th>
              <IntlMessages id="template.title" />
            </th>
            <th>
              <IntlMessages id="template.text" />
            </th>
          </tr>
        </thead>
        <tbody>
          {templateMessages &&
            templateMessages.language &&
            dropDownValue &&
            (dropDownValue === "all" || dropDownValue === "hepsi") &&
            Object.keys(templateMessages.language).map(langs =>
              templateMessages.language[langs].map((item, index) => (
                <tr key={index}>
                  <td>{langs}</td>
                  <td>{item.title}</td>
                  <td>{item.text}</td>
                  <td>
                    <Button
                      onClick={() => {
                        setFormTitle(item.title);
                        setFormText(item.text);
                        setFormLang(langs);
                        toggleEdit();
                      }}
                      href="#"
                      color="light"
                      type="button"
                      className="btn outline-light flex-grow-1 ml-3 mr-2"
                      size="xs"
                    >
                      <i className="simple-icon-pencil" />
                    </Button>
                    <Button
                      onClick={() => {
                        setFormLang(langs);
                        setDeleteValue(item);
                        toggleDelete();
                      }}
                      href="#"
                      color="light"
                      type="button"
                      className="btn outline-light flex-grow-1 ml-3 mr-2"
                      size="xs"
                    >
                      <i className="simple-icon-close" />
                    </Button>
                  </td>
                </tr>
              ))
            )}
          {templateMessages &&
            templateMessages.language &&
            templateMessages.language[dropDownValue] &&
            templateMessages.language[dropDownValue] !== "all" &&
            templateMessages.language[dropDownValue].map((item, index) => (
              <tr key={index}>
                <td>{dropDownValue}</td>
                <td>{item.title}</td>
                <td>{item.text}</td>
                <td>
                  <Button
                    onClick={() => {
                      setFormTitle(item.title);
                      setFormText(item.text);
                      setFormLang(dropDownValue);
                      toggleEdit();
                    }}
                    href="#"
                    color="light"
                    type="button"
                    className="btn outline-light flex-grow-1 ml-3 mr-2"
                    size="xs"
                  >
                    <i className="simple-icon-pencil" />
                  </Button>
                  <Button
                    onClick={async () => {
                      setFormLang(dropDownValue);
                      await setDeleteValue(item);
                      toggleDelete();
                    }}
                    href="#"
                    color="light"
                    type="button"
                    className="btn outline-light flex-grow-1 ml-3 mr-2"
                    size="xs"
                  >
                    <i className="simple-icon-close" />
                  </Button>
                </td>
              </tr>
            ))}
        </tbody>
      </Table>
      <Modal toggle={toggleDelete} isOpen={openDelete}>
        <ModalHeader>
          <IntlMessages id="template.delete-title" />
        </ModalHeader>
        <ModalBody>
          <IntlMessages id="template.delete" />{" "}
        </ModalBody>
        <ModalFooter>
          <Button
            color="light"
            onClick={() => {
              toggleDelete();
            }}
          >
            <IntlMessages id="template.cancel" />
          </Button>
          <Button
            color="primary"
            onClick={() => {
              deleteTemp(deleteValue);
              openNotificationWithIcon("success");
              toggleDelete();
            }}
          >
            <IntlMessages id="template.delete-button" />
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
};

const mapStateToProps = ({ settings }) => {
  return { settings };
};
export default injectIntl(connect(mapStateToProps)(TemplateMessageTable));
